
	import { Component, Vue } from 'vue-property-decorator';
	import { $bus } from '@/HostApp/services/Bus';
	import aps from '@/HostApp/store/ApsModules/ApsModule';

	import { MODAL_DIALOG } from '@/HostApp/store/ApsModules/AppModule';

	@Component({
		components: {}
	})
	export default class TheModalDialog extends Vue {
		protected inserted = false;
		protected dialog = false;
		protected title = '';
		protected description = '';
		protected controls: Array<APS.IModalDialogButton> = [];

		protected created(): void {
			/**
			 * to avoid lazy rendering el-dialog,
			 * because legacy aps application will render iframes
			 * inside the body of this DOM node
			 */

			this.dialog = true;

			// APS legacy app sends events to show dialogs -> src/js/host/Modal.js
			window.addEventListener('HOST-OPEN-MODAL' as never, this.openDialog);
			window.addEventListener('HOST-MODAL-SET-CONTROLS' as never, this.setControls);
		}

		protected mounted(): void {
			this.$nextTick(this.closeDialog);
		}

		protected beforeDestroy(): void {
			window.removeEventListener('HOST-OPEN-MODAL' as never, this.openDialog);
			window.removeEventListener('HOST-MODAL-SET-CONTROLS' as never, this.setControls);
		}

		protected openDialog(event: CustomEvent): void {
			this.title = event.detail.title;
			this.description = event.detail.description;

			this.dialog = true;
		}

		protected closeDialog(): void {
			this.dialog = false;
		}

		protected setControls(event: CustomEvent): void {
			this.controls = (event.detail.controls as Array<APS.IModalDialogButton>)
				.filter((control) => control.id === 'submitPopupNav' || control.id === 'cancelPopupNav')
				.reduce((acc, control) => {
					// change some property to show legacy controls
					control.action = control.id === 'submitPopupNav' ? 'submit' : 'cancel';
					control.type =
						control.type === ('success' as APS.BtnTypes) ? ('primary' as APS.BtnTypes) : control.type;

					acc.push(control);

					return acc;
				}, [] as Array<APS.IModalDialogButton>);
		}

		private createSubmitCancelPromise(): Promise<void> {
			return new Promise((resolve) => {
				$bus.$once(MODAL_DIALOG.CLOSE_POPUP, resolve);
			});
		}

		onSubmit(): Promise<void> {
			//@ts-ignore
			window.aps.app.onSubmit();
			return this.createSubmitCancelPromise();
		}

		onCancel(): Promise<void> {
			//@ts-ignore
			window.aps.app.onCancel();
			return this.createSubmitCancelPromise();
		}

		onBeforeClose = async (done: (close?: boolean) => void, status: 'submit' | 'cancel'): Promise<void> => {
			if (window.aps.apsc.dialogType === 'popup') {
				status === 'submit' ? await this.onSubmit() : await this.onCancel();
				done();
			} else {
				done();
			}
		};

		protected handleDialogClosed(status: 'submit' | 'cancel'): void {
			if (this.inserted) {
				aps.apsc.handleDialogClosed(status);
			} else {
				this.inserted = true;
			}
		}
	}
